import { render, staticRenderFns } from "./navbarAdminCurso.vue?vue&type=template&id=4afed6e2"
import script from "./navbarAdminCurso.vue?vue&type=script&lang=js"
export * from "./navbarAdminCurso.vue?vue&type=script&lang=js"
import style0 from "./navbarAdminCurso.vue?vue&type=style&index=0&id=4afed6e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports